import React from "react";
import { Box, Card, CardContent, Typography, Button, Chip } from "@mui/material";
import styles from "../../pages/main/WorkspacesPage/WorkspacesPage.module.css";
import SecureImage from"../Common/SecureImage";
import default_theme from "assets/themes/themes";

const ProjectCard = ({ project, onOpen, onEdit, onDelete }) => {

  return (
    <Card
      className={styles.projectCard}
      onClick={onOpen}
    >
      <Box className={styles.projectContent}>
        <Box
          className={styles.projectImageContainer}
        >
          {project.imagePreview ? (
            <SecureImage
              src={project.imagePreview}
              alt={project.name}
              className={styles.projectImage}
            />
          ) : (
            <Box className={styles.projectImagePlaceholder} />
          )}
          <Box className={styles.projectImageOverlay} />
        </Box>

        <CardContent
          className={styles.projectTextContent}
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography variant="h5" className={styles.projectTitle}>
            {project.name}
          </Typography>

          <Typography
            variant="body2"
            sx={{
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {project.description}
          </Typography>

          <Box sx={{ marginTop: "auto" }}>
            <Box sx={{ mb: 2 }}>
              {project.framework ? (
                <Chip
                  label={project.framework.name}
                  size="small"
                  sx={{
                    backgroundColor: "rgba(0,184,148,0.12)",
                    color: "#00b894",
                    fontWeight: 600,

                    height: 32,
                    fontSize: "0.85rem",

                    borderRadius: "10px",
                    border: "1px solid rgba(0,184,148,0.25)",

                    boxShadow: "0 2px 8px rgba(0,184,148,0.12)",

                    "& .MuiChip-label": {
                      px: 1.5,
                    },
                  }}
                />
              ) : (
                <Chip
                  label="No framework"
                  size="small"
                  variant="outlined"
                  sx={{
                    height: 32,
                    fontSize: "0.85rem",
                    borderRadius: "10px",

                    backgroundColor: "rgba(0,0,0,0.03)",
                    borderColor: "rgba(0,0,0,0.12)",

                    "& .MuiChip-label": {
                      px: 1.5,
                    },
                  }}
                />
              )}
            </Box>

            <Box sx={{ display: "flex", gap: 1, marginTop: 1 }}>
              <Button
                variant="contained"
                className={styles.projectButton}
                onClick={(e) => {
                  e.stopPropagation();
                  onOpen();
                }}
              >
                Open Project
              </Button>

              <Button
                variant="contained"
                className={styles.projectButton}
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit();
                }}
              >
                Edit
              </Button>
              <Button
                variant="contained"
                className={styles.projectDeleteButton}
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete();
                }}
              >
                Delete
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Box>
    </Card>
  );
};

export default ProjectCard;